import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Run the following command in your shell. The next time you run `}<a parentName="p" {...{
        "href": "https://www.anthropic.com/claude-code"
      }}>{`Claude Code`}</a>{`, it will have access to the PostHog MCP.`}</p>
    <MCPConfigSnippet variant="claude-code" mdxType="MCPConfigSnippet" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      